import cx from "classnames";
import React, { useState } from "react";

import * as styles from "./GameConceptListFilterButton.module.css";

type GameConceptListFilterButtonProps = Readonly<{
  title: string;
  isActive: boolean;
  onClick: () => void;
}>;

export const GameConceptListFilterButton = ({
  title,
  isActive,
  onClick,
}: GameConceptListFilterButtonProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === "Enter") {
      setIsFocused(false);
    }
  };

  return (
    <button
      className={cx(styles.tabButton, {
        [styles.active]: isActive && !isFocused,
        [styles.focus]: isFocused,
      })}
      onClick={onClick}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
    >
      {title}
    </button>
  );
};
